import React from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import ThemeProvider from './ThemeProvider';

import Overview from './overview/Overview.jsx';
import DeepstreamProvider from './editor/DeepstreamProvider.jsx';
import Editor from './editor/Editor.jsx';
import '../App.css';

const App = () => {
  return (
    <div className="App">
      <ThemeProvider>
        <Router>
          <div className="content">
            <Route path="/boards" exact component={() => <Overview activeView="all" />} />
            <Route path="/boards/own" exact component={() => <Overview activeView="own" />} />
            <Route path="/boards/shared" exact component={() => <Overview activeView="shared" />} />
            <Route path="/templates" component={() => <Overview activeView="templates" />} />
            <Route path="/board/:boardId">
              <DeepstreamProvider>
                <Editor />
              </DeepstreamProvider>
            </Route>
          </div>
          <footer className="footer">{/*	<Upgrade /> */}</footer>
        </Router>
      </ThemeProvider>
    </div>
  );
};

export default App;
